// NovedadesRouter.js
import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom'; // Import Routes and Route
import { t } from "@lingui/core/macro";
import { useLingui } from "@lingui/react"; // Import useLingui
import NewsHeader from '../components/NewsHeader/NewsHeader';
import PostSummaryList from '../components/PostSummaryList/PostSummaryList'; // Renders list of summaries
import BlogPostDetail from '../components/BlogPostDetail/BlogPostDetail'; // Renders full post
import allBlogPosts from '../data/blogPosts'; // Our simulated data
import { useLocation } from 'react-router-dom';

const NovedadesRouter = () =>
{
    const { pathname } = useLocation(); // esto es para que al clickear en una news, scrollee al top
    useEffect(() => {
    window.scrollTo(0, 0);
    }, [pathname]);
    const { i18n } = useLingui(); // Get the Lingui i18n object to access the current locale
    const titleLine1 = t`CONOZCA LAS`;
    const titleLine2 = t`NOVEDADES`;
    const description = t`Para conocer más sobre nuestras acciones en el sector.`;
    //const button = t`CONOCER MÁS`;
        useEffect(() =>
	{
	    document.title = t`The Cosmic Shores - Novedades`
    }, [titleLine1])
    //sort posts by date
    const currentLocale = i18n.locale;
    const postsForCurrentLocale = allBlogPosts[currentLocale] || allBlogPosts['es'] || [];

    // const sortedPosts = [...postsForCurrentLocale].sort((a, b) => b.date.getTime() - a.date.getTime()); // no hace falta sortear porque se sortean al crear js

    return (
        <div>
            <NewsHeader titleLine1={titleLine1} titleLine2={titleLine2} description={description}/>
            <Routes>
                {/* Route for displaying the list of all blog posts (summaries) */}
                <Route path="/" element={<PostSummaryList posts={postsForCurrentLocale} />} />
                {/* Route for displaying a single blog post in full detail */}
                <Route path=":postSlug" element={<BlogPostDetail posts={postsForCurrentLocale} />} />
            </Routes>
        </div>
    );
};

export default NovedadesRouter;

